export var Position;
(function (Position) {
    Position["RIGHT"] = "RIGHT";
    Position["LEFT"] = "LEFT";
})(Position || (Position = {}));
export var ChemotherapyStatus;
(function (ChemotherapyStatus) {
    ChemotherapyStatus["PENDING"] = "P";
    ChemotherapyStatus["STARTED"] = "I";
    ChemotherapyStatus["ADMINISTERED"] = "C";
    ChemotherapyStatus["SUSPENDED"] = "S";
    ChemotherapyStatus["CHECKED_FIRST"] = "Q";
})(ChemotherapyStatus || (ChemotherapyStatus = {}));
export var MedicationStatus;
(function (MedicationStatus) {
    MedicationStatus["ADMINISTERED"] = "ADMINISTERED";
    MedicationStatus["CHECKED_FIRST"] = "CHECKED_FIRST";
    MedicationStatus["INTERRUPTED"] = "INTERRUPTED";
    MedicationStatus["PENDING"] = "PENDING";
    MedicationStatus["PENDING_REFUSAL"] = "PENDING_REFUSAL";
    MedicationStatus["PREPARATION"] = "PREPARATION";
    MedicationStatus["REFUSED_ADMINISTERED"] = "REFUSED_ADMINISTERED";
    MedicationStatus["STARTED"] = "STARTED";
})(MedicationStatus || (MedicationStatus = {}));
//# sourceMappingURL=medication-or-solution-details-card-types.js.map